export default "__VITE_ASSET__D6JZ7Irp__"